<dx-toolbar [items]="toolbarItems"></dx-toolbar>
<div class="grid-container">
  <dx-data-grid
    [dataSource]="functionalities$ | async"
    [columns]="columnsFunctionalities"
    keyExpr="id"
    [selectedRowKeys]="selectedRowKeys"
    [showBorders]="true"
    (onSelectionChanged)="onSelectionChanged($event)"
    [filterRow]="{
      visible: true
    }"
    [allowColumnResizing]="true"
  >
    <dxo-editing [allowUpdating]="true" [useIcons]="true" mode="popup" newRowPosition="last"> </dxo-editing>
    <dxo-selection [allowSelectAll]="true" mode="multiple"></dxo-selection>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>

<dx-popup
  *ngIf="visible"
  title="Functionality"
  [hideOnOutsideClick]="true"
  [height]="400"
  [visible]="true"
  [width]="500"
  (onHiding)="hidePopup()"
>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="saveBtnOptions"> </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelBtnOptions"> </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="functionalityFormGroup">
      <dx-text-box
        formControlName="name"
        label="Name*"
        labelMode="floating"
        stylingMode="outlined"
        [validationStatus]="
          functionalityFormGroup.controls.name.errors && functionalityFormGroup.controls.name.touched ? 'invalid' : 'valid'
        "
        [validationErrors]="[{ type: 'required', message: 'Name is mandatory!' }]"
      ></dx-text-box>
      <dx-tag-box
        formControlName="groups"
        label="Groups"
        labelMode="floating"
        [dataSource]="groups"
        displayExpr="name"
        [showClearButton]="true"
        [acceptCustomValue]="true"
        customItemCreateEvent="focusout"
        (onCustomItemCreating)="onCustomItemCreating($event)"
        [searchEnabled]="true"
        searchExpr="name"
        stylingMode="outlined"
      ></dx-tag-box>
    </form>
  </div>
</dx-popup>

<dx-popup
  *ngIf="visibleDelete"
  title="Deletion"
  [hideOnOutsideClick]="true"
  [height]="250"
  [visible]="true"
  [width]="350"
  (onHiding)="hideDeletePopup()"
>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="deleteBtnOptions"> </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="cancelDeleteBtnOptions"> </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    Are you sure to delete <strong>{{ selectedFuncs.join(", ") }}</strong
    >?
  </div>
</dx-popup>
